<template>
  <v-panel>
    <v-form ref="form" v-model="valid" >
      <div class="divider">
        <span>
          <b>Dados das Receitas - Bovinos para Abate e Consumo Próprio</b>
        </span>
      </div>
      <v-flex md11>
        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Fêmeas + 36 meses para abate</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas36ValorUnitarioRS"
              v-model="formulario.femeas36ValorUnitarioRS"
              type="number"
              background-color="white"
              label="R$/@"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs8 sm6 md6>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="femeas36PesoMedioKGVivo"
                  v-model="formulario.femeas36PesoMedioKGVivo"
                  type="number"
                  background-color="white"
                  label="kg vivo"
                  box                  
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="femeas36PesoMedioCarcaca"
                  v-model="formulario.femeas36PesoMedioCarcaca"
                  type="number"
                  background-color="white"
                  label="Carcaça"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas36cabeca"
              v-model="formulario.femeas36cabeca"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>

        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Fêmeas 24-36 meses para abate</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas2436ValorUnitarioRS"
              v-model="formulario.femeas2436ValorUnitarioRS"
              type="number"
              background-color="white"
              label="R$/@"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs8 sm6 md6>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="femeas2436PesoMedioKGVivo"
                  v-model="formulario.femeas2436PesoMedioKGVivo"
                  type="number"
                  background-color="white"
                  label="kg vivo"
                  box                  
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="femeas2436PesoMedioCarcaca"
                  v-model="formulario.femeas2436PesoMedioCarcaca"
                  type="number"
                  background-color="white"
                  label="Carcaça"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas2436cabeca"
              v-model="formulario.femeas2436cabeca"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Fêmeas 12-24 meses para abate</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas1224ValorUnitarioRS"
              v-model="formulario.femeas1224ValorUnitarioRS"
              type="number"
              background-color="white"
              label="R$/@"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs8 sm6 md6>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="femeas1224PesoMedioKGVivo"
                  v-model="formulario.femeas1224PesoMedioKGVivo"
                  type="number"
                  background-color="white"
                  label="kg vivo"
                  box                  
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="femeas1224PesoMedioCarcaca"
                  v-model="formulario.femeas1224PesoMedioCarcaca"
                  type="number"
                  background-color="white"
                  label="Carcaça"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="femeas1224cabeca"
              v-model="formulario.femeas1224cabeca"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos 12-24 meses para abate</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos1224ValorUnitarioRS"
              v-model="formulario.machos1224ValorUnitarioRS"
              type="number"
              background-color="white"
              label="R$/@"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs8 sm6 md6>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="machos1224PesoMedioKGVivo"
                  v-model="formulario.machos1224PesoMedioKGVivo"
                  type="number"
                  background-color="white"
                  label="kg vivo"
                  box                  
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="machos1224PesoMedioCarcaca"
                  v-model="formulario.machos1224PesoMedioCarcaca"
                  type="number"
                  background-color="white"
                  label="Carcaça"
                  box
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos1224cabeca"
              v-model="formulario.machos1224cabeca"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div class="divider2 text-xs-center">
          <span class="headline">
            <b>Machos 24-36 meses para abate</b>
          </span>
        </div>
        <v-divider></v-divider>

        <v-layout align-center justify-center row wrap>
          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos2436ValorUnitarioRS"
              v-model="formulario.machos2436ValorUnitarioRS"
              type="number"
              background-color="white"
              label="R$/@"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs8 sm6 md6>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="machos2436PesoMedioKGVivo"
                  v-model="formulario.machos2436PesoMedioKGVivo"
                  type="number"
                  background-color="white"
                  label="kg vivo"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="machos2436PesoMedioCarcaca"
                  v-model="formulario.machos2436PesoMedioCarcaca"
                  type="number"
                  background-color="white"
                  label="Carcaça"
                  box
                ></v-text-field>
              </v-flex> 
            </v-layout>
          </v-flex>

          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos2436cabeca"
              v-model="formulario.machos2436cabeca"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>

        </v-layout>

        <v-flex text-xs-center>
          <div class="divider2 text-xs-center">
            <span class="headline">
              <b>Machos + 36 meses inclusive tourunos para abate</b>
            </span>
          </div>
          <v-divider></v-divider>
        </v-flex>
        <v-layout align-center justify-center row wrap>
          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Valor</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos36ValorUnitarioRS"
              v-model="formulario.machos36ValorUnitarioRS"
              type="number"
              background-color="white"
              label="R$/@"
              box
            ></v-text-field>
          </v-flex>

          <v-flex xs8 sm6 md6>
            <div class="text-xs-center">
              <span>
                <b>Peso médio</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-layout align-center justify-center row wrap>
              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="machos36PesoMedioKGVivo"
                  v-model="formulario.machos36PesoMedioKGVivo"
                  type="number"
                  background-color="white"
                  label="kg vivo"
                  box
                ></v-text-field>
              </v-flex>

              <v-flex xs4 sm3 md3>
                <v-text-field
                  name="machos36PesoMedioCarcaca"
                  v-model="formulario.machos36PesoMedioCarcaca"
                  type="number"
                  background-color="white"
                  label="Carcaça"
                  box
                ></v-text-field>
              </v-flex>
              {{form}}
            </v-layout>
          </v-flex>
          <v-flex xs4 sm2 md2>
            <div class="text-xs-center">
              <span>
                <b>Quantidade</b>
              </span>
            </div>
            <v-divider></v-divider>
            <v-text-field
              name="machos36cabeca"
              v-model="formulario.machos36cabeca"
              type="number"
              background-color="white"
              label="Cabeças"
              box
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-form>
  </v-panel>
</template>
<script>
/* eslint-disable */
import ReceitaAnualAbate from "../../class/ReceitaAnualAbate.js";
export default {
  inject: ["$validator"],
  data: () => ({
    formulario: new ReceitaAnualAbate(),
    panel: [],
    lazy: true,
    valid: false,
    simulation: ''
  }),
  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed: {
    form: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        this.formulario = new ReceitaAnualAbate(dado.bovinoAbate);
      });
    }
  },
  methods: {
    clear() {
      this.formulario = {
        formulario: Object.assign(this.$data, this.$options.data.apply())
      };
      this.$validator.reset();
    }
  }
};
</script>
<style scoped>
h2 {
  color: #00695c;
}

.botaoNone {
  border: solid black 1px;
  position: fixed;
  margin-bottom: 0;
  z-index: 997;
  bottom: 45px;
  right: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

@media screen and (max-width: 991px) {
  h2 {
    color: #00695c;
  }
  .container {
    position: relative;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }

  .panel {
    margin-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 15px black;
  }
  .form {
    margin-top: 2%;

    min-width: 100%;
  }
  .text-field {
    background-color: blue;
    font-size: 2px;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }
  .button {
    float: right;
  }
  .divider {
    text-align: center;
    font-size: 130%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    margin-top: 5%;
    margin-left: 5%;
    font-size: 110%;
  }
}

@media screen and (min-width: 992px) {
  h2 {
    color: #00695c;
  }
  .container {
    margin-top: 2%;
    text-align: center;

    background-color: #00695c;
    min-height: 100vh;
    max-width: none;

    color: azure;
  }
  .panel {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    padding-bottom: 1%;
    background-color: white;
    box-shadow: 0 4px 10px black;
  }
  .panelGrafico {
    width: 70%;
  }
  .flex {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
  }

  .button {
    float: right;
  }

  .divider {
    text-align: center;
    font-size: 180%;
    color: #00695c;
  }
  .divider2 text-xs-center {
    font-size: 150%;
    margin-top: 5%;
    margin-left: 5%;
  }
  .layout {
    padding-left: 5%;
    padding-right: 5%;
  }
}
</style>